import truLogo from "../../assets/Images/truLogo.png";
import searchBar from "../../assets/Images/searchBar.png";
import loginIcon from "../../assets/Images/loginIcon.png";
import landingBG from "../../assets/Images/landingBG.png";
import Arrow from "../../assets/Images/Arrow.png";
import landingBG2 from "../../assets/Images/landingBG2.png";
import landingBG3 from "../../assets/Images/landingBG3.png";
import landingBG4 from "../../assets/Images/landingBG4.png";
import landingDiscoverImg from "../../assets/Images/landingDiscoverImg.png";
import buttonArrow from "../../assets/Images/buttonArrow.png";
import TRUBARBER from "../../assets/Images/TRUBARBER.png";
import truLogoTwo from "../../assets/Images/truLogoTwo.png";
import signinBG from "../../assets/Images/signinBG.png";
import email from "../../assets/Images/email.png";
import password from "../../assets/Images/password.png";
import eye from "../../assets/Images/eye.png";
import eyeOff from "../../assets/Images/eyeOff.png";
import arrowBtn from "../../assets/Images/arrowBtn.png";
import arrowBtnBlack from "../../assets/Images/arrowBtnBlack.png";
import backBtnLight from "../../assets/Images/backBtnLight.png";
import backBtnDark from "../../assets/Images/backBtnDark.png";
import user from "../../assets/Images/user.png";
import phone from "../../assets/Images/phone.png";
import check from "../../assets/Images/check.png";
import unCheck from "../../assets/Images/unCheck.png";
import profileUpload from "../../assets/Images/profileUpload.png";
import uploadBtn from "../../assets/Images/uploadBtn.png";
import barberImg from "../../assets/Images/barberImg.png";
import star from "../../assets/Images/star.png";
import Location from "../../assets/Images/Location.png";
import congratulations from "../../assets/Images/congratulations.png";
import instagram from "../../assets/Images/instagram.png";
import clock from "../../assets/Images/clock.png";
import greyArrow from "../../assets/Images/greyArrow.png";
import cross from "../../assets/Images/cross.png";
import uploadGray from "../../assets/Images/uploadGray.png";
import deleteService from "../../assets/Images/deleteService.png";
import addWhite from "../../assets/Images/addWhite.png";
import edit from "../../assets/Images/edit.png";
import deleteIcon from "../../assets/Images/delete.png";
import beardDisplayPicture from "../../assets/Images/beardDisplayPicture.png";
import haircutDisplayPicture from "../../assets/Images/haircutDisplayPicture.png";
import reviewBarber from "../../assets/Images/reviewBarber.png";
import google from "../../assets/Images/google.png";
import apple from "../../assets/Images/apple.png";
import facebook from "../../assets/Images/facebook.png";
import twitter from "../../assets/Images/twitter.png";
import insta from "../../assets/Images/insta.png";
import logout from "../../assets/Images/logout.png";
import explore from "../../assets/Images/explore.png";
import wallet from "../../assets/Images/wallet.png";
import appointment from "../../assets/Images/appointment.png";
import profile from "../../assets/Images/profile.png";
import editProfile from "../../assets/Images/editProfile.png";
import privacy from "../../assets/Images/privacy.png";
import security from "../../assets/Images/security.png";
import editProfileWhite from "../../assets/Images/editProfileWhite.png";
import securityWhite from "../../assets/Images/securityWhite.png";
import notificationIcon from "../../assets/Images/notificationIcon.png";
import bookmarkIcon from "../../assets/Images/bookmarkIcon.png";
import chatIcon from "../../assets/Images/chatIcon.png";
import barberAppointmentImg from "../../assets/Images/barberAppointmentImg.png";
import walletBlack from "../../assets/Images/walletBlack.png";
import male from "../../assets/Images/male.png";
import female from "../../assets/Images/female.png";
import BG from "../../assets/Images/BG.png";
import uploadProfile from "../../assets/Images/uploadProfile.png";
import checkbox from "../../assets/Images/checkbox.png";
import checkboxMarked from "../../assets/Images/checkboxMarked.png";
import truLogoForWhite from "../../assets/Images/truLogoForWhite.png";
import bookmarkBlack from "../../assets/Images/bookmarkBlack.png";
import bookmarkDissable from "../../assets/Images/bookmarkDissable.png";
import direction from "../../assets/Images/direction.png";
import message from "../../assets/Images/message.png";
import businessImage from "../../assets/Images/businessImage.png";
import appointmentConfirm from "../../assets/Images/appointmentConfirm.png";
import arrowBlackIcon from "../../assets/Images/arrowBlackIcon.png";
import chatImg from "../../assets/Images/chatImg.png";
import catalouge from "../../assets/Images/catalouge.png";
import starLight from "../../assets/Images/starLight.png";
import haircutIcon from "../../assets/Images/haircutIcon.png";
import beardIcon from "../../assets/Images/beardIcon.png";
import businessBefore from "../../assets/Images/businessBefore.png";
import businessAfter from "../../assets/Images/businessAfter.png";

const images = {
  starLight,
  catalouge,
  chatImg,
  arrowBlackIcon,
  appointmentConfirm,
  direction,
  message,
  bookmarkBlack,
  bookmarkDissable,
  truLogoForWhite,
  BG,
  male,
  female,
  edit,
  deleteIcon,
  addWhite,
  deleteService,
  uploadGray,
  cross,
  clock,
  instagram,
  congratulations,
  uploadBtn,
  profileUpload,
  check,
  unCheck,
  phone,
  user,
  backBtnLight,
  backBtnDark,
  arrowBtnBlack,
  arrowBtn,
  signinBG,
  email,
  password,
  eye,
  eyeOff,
  landingBG4,
  landingBG3,
  landingBG2,
  truLogo,
  searchBar,
  loginIcon,
  landingBG,
  Arrow,
  landingDiscoverImg,
  buttonArrow,
  TRUBARBER,
  truLogoTwo,
  barberImg,
  star,
  Location,
  greyArrow,
  beardDisplayPicture,
  haircutDisplayPicture,
  reviewBarber,
  google,
  apple,
  facebook,
  twitter,
  insta,
  logout,
  explore,
  wallet,
  appointment,
  profile,
  editProfile,
  privacy,
  security,
  editProfileWhite,
  securityWhite,
  notificationIcon,
  bookmarkIcon,
  chatIcon,
  barberAppointmentImg,
  walletBlack,
  uploadProfile,
  checkboxMarked,
  checkbox,
  businessImage,
  haircutIcon,
  beardIcon,
  businessBefore,
  businessAfter
};

export default images;
